module.exports = __webpack_public_path__ + "static/media/minimize_filled.abb7df1a.svg";